<template>
  <v-content>
    <OLoadingDialog :value="isLoading" />
    <AccountDetailsDialog ref="detailsDialog" />

    <div class="full-width">
      <v-toolbar flat class="card-bar">
        <v-toolbar-title>Pessoas</v-toolbar-title>
        <v-btn icon @click="reload" class="ml-2">
          <v-icon>refresh</v-icon>
        </v-btn>
        <OSelectColsButton :fullSpec="fullSpec" v-model="vars" />
        <v-spacer />

        <v-text-field
          :value="keywords"
          @change="v => (keywords = v)"
          append-icon="search"
          label="Filtro por palavra-chave..."
          clearable
          @click:clear="keywords = null"
          single-line
          hide-details
          class="pa-0"
        />

        <v-spacer />

        <v-switch
          v-model="includeInactive"
          label="Mostrar inativas"
          hide-details
          class="pa-0 ml-5"
        />

        <v-spacer />

        <v-btn color="primary" class="mr-2" @click="newAccount">
          Novo Cadastro...
        </v-btn>
      </v-toolbar>

      <OPaginatedTable
        :spec="spec"
        :items="rows"
        :count="count"
        :navigation="nav"
        @update:navigation="v => (nav = v)"
        noData="Não existem registros para o filtro informado."
        @rowClicked="selectRow"
      />
    </div>
  </v-content>
</template>

<script>
import { Account } from '@/models'
import { clearEmptyValues } from 'oderon-commons/src/utils'
import { fullSpec } from './account-columns'
import { getPref, savePref } from 'oderon-vue/Prefs'
import { selectCols } from 'oderon-commons/src/tables'

const _key = 'oderonAccountCols'

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    OPaginatedTable: require('oderon-vue/cpts/OPaginatedTable').default,
    AccountDetailsDialog: require('./AccountDetailsDialog').default,
    OSelectColsButton: require('oderon-vue/cpts/OSelectColsButton.vue').default
  },
  data() {
    return {
      isLoading: false,
      includeInactive: false,
      keywords: null,

      fullSpec,
      vars: getPref(_key, fullSpec.defCodes),

      count: null,
      nav: {
        offset: 0,
        limit: 20,
        sortBy: 'email',
        sortDir: 'asc'
      },
      rows: []
    }
  },
  computed: {
    spec() {
      return selectCols(this.fullSpec, this.vars)
    },

    // quando estes mudam, volta para a página 0
    filterParams() {
      return {
        keywords: this.keywords,
        onlyActive: !this.includeInactive,
        order: this.nav.sortBy + ' ' + this.nav.sortDir
      }
    },

    // quando estes mudam, chama a API
    apiParams() {
      return clearEmptyValues({
        ...this.filterParams,
        limit: this.nav.limit,
        offset: this.nav.offset
      })
    }
  },
  watch: {
    vars() {
      savePref(_key, this.vars)
    },
    filterParams() {
      this.nav.offset = 0
    },
    apiParams() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let res = await Account.findAll(this.apiParams)
      this.rows = res.rows
      this.count = res.count
    },

    async newAccount() {
      let email = await this.$prompt({
        label: 'Digite o email do novo usuário:'
      })

      if (email != null) await this.createAccount({ email })
    },

    async createAccount({ email }) {
      let created = null
      await this.$loading(async () => {
        created = await Account.save({ email })
        await this.fetchData()
      })

      this.selectRow(created)
    },

    selectRow(r, index, evt) {
      let id = r.id
      if (evt && (evt.ctrlKey || evt.button == 1)) {
        window.open(`/#/tools/gateman/accounts/${id}`, '_blank')
      } else {
        this.$router.push(`/tools/gateman/accounts/${id}`)
      }
    }
  }
}
</script>

<style></style>
